const mergeColumn = (columns, columnUpdated) => {
  try {
    // Handle column reordering (from onColumnOrderChange)
    if (columnUpdated.oldIndex !== undefined && columnUpdated.targetIndex !== undefined) {
      // Create a copy and reorder columns
      const reorderedColumns = [...columns];
      const [movedColumn] = reorderedColumns.splice(columnUpdated.oldIndex, 1);
      reorderedColumns.splice(columnUpdated.targetIndex, 0, movedColumn);
      return reorderedColumns;
    }

    // Handle column resize and visibility changes
    let updatedColumns = columns.map(c => {
      if (c.field === columnUpdated.colDef.field) {
        return {
          ...c,
          width: columnUpdated.colDef.width !== undefined ? columnUpdated.colDef.width : c.width ?? 130,
          hide: columnUpdated.colDef.hide !== undefined ? columnUpdated.colDef.hide : c.hide ?? false
        };
      }
      return c;
    });

    return updatedColumns;
  } catch (e) {
    return columns;
  }
};

// Add new columns to user settings based on the order in datagrid columns definition
const addNewColumnsToUserColumns = (userColumns, defaultColumns, newDefaultColumns) => {
  // Pair each new column with its position in the default column order.
  const newColumns = newDefaultColumns.map((newCol) => ({
    col: newCol,
    index: defaultColumns.findIndex((defaultCol) => defaultCol.field === newCol.field)
  }));

  // Insert each new column relative to its immediate left neighbor from default columns.
  newColumns.forEach(({ col, index }) => {
    // Resolve the field that should appear immediately before this new column.
    const leftField = index > 0 ? defaultColumns[index - 1].field : undefined;

    // If there is no left neighbor, place the column at the beginning.
    if (!leftField) {
      userColumns.splice(0, 0, col);
      return;
    }

    // Find the left neighbor in user columns and insert to its right when found.
    const leftIndexInUserColumns = userColumns.findIndex(c => c.field === leftField);
    if (leftIndexInUserColumns >= 0) {
      userColumns.splice(leftIndexInUserColumns + 1, 0, col);
    } else {
      // Fallback: append column to the end when the expected left neighbor is not present.
      userColumns.push(col);
    }
  });
};

export const getDataGridColumns = (dataGridId, defaultColumns) => {
  try {
    var savedColumns = JSON.parse(localStorage.getItem(dataGridId));
    if (!savedColumns || savedColumns.length === 0) {
      return defaultColumns;
    }

    const userColumns = savedColumns.map((userCol) => {
      const defaultCol = defaultColumns.find((d) => d.field === userCol.field);
      return defaultCol ? { ...defaultCol, ...userCol } : userCol;
    });

    const userColumnsSet = new Set(userColumns.map(c => c.field));
    const newDefaultColumns = defaultColumns.filter(
      (defaultCol) => !userColumnsSet.has(defaultCol.field)
    );
    if (newDefaultColumns.length > 0) {
      addNewColumnsToUserColumns(userColumns, defaultColumns, newDefaultColumns);
    }
    
    // Save the merged columns back to maintain consistency
    localStorage.setItem(dataGridId, JSON.stringify(userColumns));
    return userColumns;
  } catch (e) {
    return defaultColumns;
  }
};

export const saveDataGridColumns = (dataGridId, defaultColumns, columnUpdated) => {
  try {
    var userColumns = JSON.parse(localStorage.getItem(dataGridId));
    let columns = defaultColumns;
    if (userColumns) {
      columns = userColumns;
    }
    const updatedColumns = mergeColumn(columns, columnUpdated);
    localStorage.setItem(dataGridId, JSON.stringify(updatedColumns));
  } catch (e) {
    console.log(e);
  }
};
